import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Bell, Calendar, BookOpen, Wallet, AlertCircle } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";

const ICONS = {
  fee: Wallet, exam: Calendar, material: BookOpen, attendance: AlertCircle, system: Bell,
};

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ message:"", type:"system" });

  const load = async () => setItems((await api.get("/notifications")).data);
  useEffect(()=>{load()},[]);

  const create = async (e) => {
    e.preventDefault();
    await api.post("/notifications", { ...form, read:false });
    setOpen(false); toast.success("Notification sent"); load();
  };

  return (
    <div>
      <PageHeader title="Notifications" subtitle="Communication broadcasts"
        actions={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><button className="btn-primary" data-testid="add-notification-btn">+ Broadcast</button></DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Broadcast notification</DialogTitle></DialogHeader>
              <form onSubmit={create} className="space-y-3">
                <textarea required placeholder="Message" data-testid="notif-message-input" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md min-h-[100px]" value={form.message} onChange={e=>setForm({...form, message:e.target.value})}/>
                <select data-testid="notif-type-select" className="w-full px-3 py-2 border border-[#E0DFDC] rounded-md bg-white" value={form.type} onChange={e=>setForm({...form, type:e.target.value})}>
                  {["system","fee","exam","material","attendance"].map(x=><option key={x}>{x}</option>)}
                </select>
                <DialogFooter><button className="btn-primary" data-testid="notif-send-btn">Send</button></DialogFooter>
              </form>
            </DialogContent>
          </Dialog>
        }
      />
      <div className="linkedin-card divide-y divide-[#E0DFDC]" data-testid="notifications-list">
        {items.map((n) => {
          const Icon = ICONS[n.type] || Bell;
          return (
            <div key={n.id} className="p-4 flex items-start gap-3 hover:bg-[#0000000A]" data-testid={`notif-${n.id}`}>
              <div className="w-10 h-10 rounded-md bg-[#EAF3FB] text-[#0A66C2] flex items-center justify-center flex-shrink-0"><Icon size={18}/></div>
              <div className="flex-1 min-w-0">
                <div className="text-sm text-[#000000E6]">{n.message}</div>
                <div className="text-[11px] text-[#00000099] uppercase tracking-wider mt-1">{n.type} · {new Date(n.created_at).toLocaleString()}</div>
              </div>
              {!n.read && <span className="w-2 h-2 rounded-full bg-[#0A66C2] mt-2"/>}
            </div>
          );
        })}
        {items.length === 0 && <div className="p-8 text-center text-sm text-[#00000099]">No notifications</div>}
      </div>
    </div>
  );
}
